class CollectionStickySearch extends HTMLElement {
  connectedCallback() {
    this.threshold = Number(this.dataset.scrollThreshold || 300);
    this.input = this.querySelector('.collection-sticky-search__input');
    this.clearBtn = this.querySelector('[data-sticky-clear]');
    this._scrollTicking = false;
    this._keyboardOpen = false;

    this.onScroll = this.onScroll.bind(this);
    this.onViewportChange = this.onViewportChange.bind(this);
    this.onInputFocus = this.onInputFocus.bind(this);
    this.onInputBlur = this.onInputBlur.bind(this);

    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.onScroll();

    this.input?.addEventListener('focus', this.onInputFocus);
    this.input?.addEventListener('blur', this.onInputBlur);
    this.input?.addEventListener('input', () => this.syncClearButton());

    this.clearBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      if (this.input) {
        this.input.value = '';
        this.input.focus();
        this.syncClearButton();
      }
    });

    this.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.input === document.activeElement) {
        this.input.blur();
      }
    });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    this.unbindViewportListeners();
  }

  onScroll() {
    if (this._scrollTicking) return;
    this._scrollTicking = true;
    window.requestAnimationFrame(() => {
      this._scrollTicking = false;
      if (this._keyboardOpen) return;

      const y = window.scrollY || document.documentElement.scrollTop;
      if (y >= this.threshold) {
        this.hidden = false;
        this.classList.add('is-visible');
      } else {
        this.hidden = true;
        this.classList.remove('is-visible');
        this.resetKeyboardPosition();
      }
    });
  }

  onInputFocus() {
    this._keyboardOpen = true;
    this.classList.add('is-keyboard-open');
    this.hidden = false;
    this.classList.add('is-visible');
    this.bindViewportListeners();
    this.onViewportChange();
  }

  onInputBlur() {
    window.setTimeout(() => {
      if (this.input === document.activeElement) return;
      this._keyboardOpen = false;
      this.classList.remove('is-keyboard-open');
      this.unbindViewportListeners();
      this.resetKeyboardPosition();
      this.onScroll();
    }, 100);
  }

  bindViewportListeners() {
    if (!window.visualViewport) return;
    window.visualViewport.addEventListener('resize', this.onViewportChange);
    window.visualViewport.addEventListener('scroll', this.onViewportChange);
  }

  unbindViewportListeners() {
    if (!window.visualViewport) return;
    window.visualViewport.removeEventListener('resize', this.onViewportChange);
    window.visualViewport.removeEventListener('scroll', this.onViewportChange);
  }

  onViewportChange() {
    const vv = window.visualViewport;
    if (!vv || !this._keyboardOpen) return;

    const gap = 12;
    const keyboardInset = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
    this.style.bottom = `${keyboardInset + gap}px`;
  }

  resetKeyboardPosition() {
    this.style.bottom = '';
  }

  syncClearButton() {
    if (!this.clearBtn || !this.input) return;
    this.clearBtn.classList.toggle('hidden', !this.input.value.length);
  }
}

if (!customElements.get('collection-sticky-search')) {
  customElements.define('collection-sticky-search', CollectionStickySearch);
}
